import { render, staticRenderFns } from "./third-self-promotion.vue?vue&type=template&id=dc34421a&scoped=true&"
import script from "./third-self-promotion.vue?vue&type=script&lang=ts&"
export * from "./third-self-promotion.vue?vue&type=script&lang=ts&"
import style0 from "./third-self-promotion.vue?vue&type=style&index=0&id=dc34421a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc34421a",
  null
  
)

export default component.exports